import {PurchaseOrderStatusEnum} from './Purchase-order.status.enum';

export class PurchaseOrderAdvancedSearch {
  purchaseOrderNumber?: string;
  supplierName?: string;
  requestNumber?: string;
  status?: PurchaseOrderStatusEnum;
  amendmentNumber?: number;

  constructor(object?: any) {
    if (object) {
      this.purchaseOrderNumber = object.purchaseOrderNumber;
      this.supplierName = object.supplierName;
      this.requestNumber = object.requestNumber;
      this.amendmentNumber = object.amendmentNumber;
      this.status = object.status;
    }
  }
}
